import { AxiosResponse } from 'axios';
import { UDNICK } from '../../../../service/udnick';

export interface IProps {
  nuNota: number;
  numNota: number;
  codFornecedor: number;
  codDestinatario: number;
  pesoBruto: number;
  valor: number;
  destinatario: string;
  fornecedor: string;
  observacao: string;
  cidadeOrigem: string;
  qtdVolume: number;
  tipoVolume: string;
  nunotaEmitida: number;
  produto: string;
  nomeCD: string;
  temAnexo: number;
}

export interface IResponse {
  pedidos: IProps;
  total: number;
}

export const SecondaryTableService = {
  getPedidosOrdemCarga: (
    ordemCarga: number,
    codEmp: number,
    parceiros: number[]
  ): Promise<AxiosResponse<IResponse>> =>
    UDNICK.callService('getPedidosOrdemCarga', {
      ordemCarga,
      codEmp,
      parceiros,
    }),
};
